import styled from 'styled-components'
import { ScrollContainerWithHiddenScrollbar } from 'builder/components/ScrollContainer'
import Media from 'builder/styles/media'

export const TailorContentWrapper = styled(ScrollContainerWithHiddenScrollbar)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: auto;
  padding-top: 4px;

  ${Media.Tablet`
    overflow-y: visible;
  `}
`
